import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../../styles/SubscriptionContainer.module.scss';
import { usePurchaseSubscriptionContext } from '../../../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import Button from '../../../../../components/Button';
import { SubscriptionAppBarSpacer } from '../../../components/SubscriptionAppBar';
import { inAppCancellation as events } from '../../../../../lib/analytics/events';
import { DateTime } from 'luxon';

export default function PauseMembershipConfirmation() {
  const { t } = useTranslation();
  const { device } = usePurchaseSubscriptionContext();

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBarSpacer />
        <div className={styles.subscriptionContainer}>
          <h1>{t('your_membership_has_been_paused_for_1_month')}</h1>
          <p>
            {t('your_will_have_access_to_the_fi_app_until_date', {
              date: DateTime.fromISO(device.subscription?.currentTermEndsAt).toFormat('L/d/yy'),
            })}
          </p>{' '}
          <p>
            {t('we_will_skip_your_next_monthly_payment_and_your_billing_will_resume_on_date', {
              date: DateTime.fromISO(device.subscription?.currentTermEndsAt).plus({ months: 1 }).toFormat('L/d/yy'),
            })}
          </p>{' '}
        </div>

        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            onClick={() => {
              events.claimPauseMembershipDone({ petId: device.pet?.id });
              window.open('fi://closeappview');
            }}
          >
            {t('done')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
